export default __webpack_public_path__ + "static/image1-144b1d36ee0c92732a53bf8bd8b8eeb2.gif";